import * as React from "react";
const SvgFiRrGreaterThan = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-greater-than_svg__a)">
      <path
        fill="#062147"
        d="M23.99 12c0 1.46-.813 2.711-2.12 3.265L1.41 23.921a1 1 0 1 1-.78-1.842l20.46-8.656c.662-.28.898-.919.898-1.423s-.236-1.143-.898-1.423L.63 1.921A1 1 0 0 1 1.41.079l20.46 8.656c1.308.553 2.12 1.804 2.12 3.265"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-greater-than_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrGreaterThan;
